import CtaLink from '@/pages/home/components/CtaLink';

const heroMetrics = [
  { value: '$550K', label: 'Client Month', cls: 'top-4 left-0' },
  { value: '$500K+', label: 'Record Month', cls: 'top-0 right-0' },
  { value: '200%', label: 'Above Goal', cls: 'bottom-24 left-0' },
  { value: '1:12', label: 'Historical ROI Benchmark', cls: 'bottom-0 right-0' },
];

const bars = [42, 58, 38, 72, 64, 88, 100, 76, 92, 70, 96, 84];

export default function ResultsHero() {
  return (
    <section className="relative overflow-hidden pt-28 md:pt-40 pb-16 md:pb-24">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 -right-24 w-[520px] h-[520px] rounded-full bg-primary-500/10 blur-[130px] animate-glow-pulse" />
        <div className="absolute bottom-0 -left-24 w-[420px] h-[420px] rounded-full bg-background-300/50 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left — copy */}
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
              <i className="ri-bar-chart-2-line"></i>
              Client Results
            </span>

            <h1 className="mt-6 font-heading font-bold text-4xl md:text-5xl lg:text-[3.2rem] leading-[1.08] text-foreground-950">
              Marketing Should Be Measured by{' '}
              <span className="text-primary-400">
                What It Does for the Business.
              </span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
              Josh Hastings helps established businesses improve the systems
              that turn marketing investment into leads, customers, and revenue.
              This page highlights selected results, experiences, and client
              feedback from businesses Josh has worked with.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <CtaLink>Apply to Work With Me</CtaLink>
              <CtaLink href="/#work-with-josh" variant="secondary">
                See How We Work
              </CtaLink>
            </div>
          </div>

          {/* Right — abstract dashboard */}
          <div className="relative">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/15 via-transparent to-background-300/40 blur-2xl" />
            <div className="relative rounded-2xl border border-white/10 bg-background-100 p-6 md:p-8">
              {/* faux chart header */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-foreground-600">
                    Revenue Performance
                  </p>
                  <p className="font-heading font-bold text-xl text-foreground-950">
                    Growth Trend
                  </p>
                </div>
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/15 text-primary-400 px-3 py-1 text-xs font-label font-semibold">
                  <i className="ri-arrow-up-line"></i>
                  Illustrative
                </span>
              </div>

              {/* faux bar chart */}
              <div className="mt-6 flex items-end gap-2 h-32">
                {bars.map((h, i) => (
                  <div
                    key={i}
                    className="flex-1 rounded-t-md bg-gradient-to-t from-primary-500/20 to-primary-400/70"
                    style={{ height: `${h}%` }}
                  />
                ))}
              </div>

              {/* floating metric cards */}
              <div className="mt-8 grid grid-cols-2 gap-3">
                {heroMetrics.map((m) => (
                  <div
                    key={m.value}
                    className="rounded-lg border border-white/8 bg-background-200/60 p-4">
                    <p className="font-heading font-extrabold text-2xl text-primary-400">
                      {m.value}
                    </p>
                    <p className="mt-1 text-xs text-foreground-600">
                      {m.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
